module.exports = __webpack_public_path__ + "static/media/abogados.ed80c038.jpg";